import React from 'react'
import { Tabs } from 'antd'
import { wtHrefHashGetVars, wtHrefHashSetVars } from 'src/helpers/commons/HrefHash'

const items = [
  {
    key: 'stock-aging-report-v2',
    label: 'Stock Agining V2',
  },
  {
    key: 'stock-aging-report',
    label: 'Stock Agining',
  },
]

export default function ReportVersionTabs({ activeKey }) {
  const handleChange = (nextKey) => {
    const currentHashParams = wtHrefHashGetVars()
    wtHrefHashSetVars({
      ...currentHashParams,
      code: nextKey,
    })
  }

  return <Tabs activeKey={activeKey} onChange={handleChange} items={items} />
}
